import { render, staticRenderFns } from "./TheButton.vue?vue&type=template&id=b94aeacc&"
import script from "./TheButton.vue?vue&type=script&lang=js&"
export * from "./TheButton.vue?vue&type=script&lang=js&"
import style0 from "./TheButton.vue?vue&type=style&index=0&id=b94aeacc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports